import { useState } from "react";
import { useDispatch } from 'react-redux';
import { updatePropertyForEmpties } from "../../../../context/fileReducer";
import { idishCardOptionA, idishCardOptionB, sum, colel, exists_card, exists_card_2 } from "../../../../common/statics";
import { update_sum, update_colel, update_idishCard_2, update_idishCard } from "../../../../texts/fill";
import "./UpdateForAllModal.css";

const UpdateForAllModal = () => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);

    const [idishCard1Value, setIdishCard1Value] = useState("");
    const [idishCard2Value, setIdishCard2Value] = useState("");
    const [sumValue, setSumValue] = useState("");
    const [colelValue, setColelValue] = useState("");

    const handleIdishCard1Change = (e) => setIdishCard1Value(e.target.value);
    const handleIdishCard2Change = (e) => setIdishCard2Value(e.target.value);
    const handleSumChange = (e) => setSumValue(e.target.value);
    const handleColelChange = (e) => setColelValue(e.target.value);

    const handleApplyIdishCard1 = () => {
        if (idishCard1Value) {
            dispatch(updatePropertyForEmpties(exists_card, idishCard1Value));
        }
    };

    const handleApplyIdishCard2 = () => {
        if (idishCard2Value) {
            dispatch(updatePropertyForEmpties(exists_card_2, idishCard2Value));
        }
    };

    const handleUpdateSum = () => {
        const numericValue = Number(sumValue);
        if (!Number.isNaN(numericValue)) {
            dispatch(updatePropertyForEmpties(sum, numericValue));
        }
    };

    const handleUpdateColel = () => {
        if (colelValue) {
            dispatch(updatePropertyForEmpties(colel, colelValue));
        }
    };

    return (
        <>
            <button
                className="btn btn-success"
                style={{
                    width: '100px',
                    height: '130px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontWeight: 600
                }}
                onClick={() => setShowModal(true)}
            >
                <span style={{ fontSize: '1.5em', marginBottom: 6 }} role="img" aria-label="update">
                    🔄
                </span>
                עדכון נתונים בקובץ
            </button>

            {showModal && (
                <div
                    className="update-modal-overlay show"
                    onClick={() => setShowModal(false)}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="update-modal-title"
                >
                    <div
                        className="update-modal-content"
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="update-modal-header">
                            <button
                                className="update-modal-close-btn"
                                onClick={() => setShowModal(false)}
                                aria-label="סגור"
                                type="button"
                            >
                                ✕
                            </button>
                            <h2 className="update-modal-header-title" id="update-modal-title">
                                עדכון נתוני קובץ
                            </h2>
                            <p className="update-modal-header-subtitle">
                                בחר כיצד לעדכן את השורות הריקות בקובץ
                            </p>
                        </div>

                        <div className="update-modal-body">
                            <div className="update-modal-cards-container">
                                <div className="update-modal-card">
                                    <div className="update-modal-card-header">
                                        <span className="update-modal-card-icon">💳</span>
                                        <h3 className="update-modal-card-title">אידיש כארד 1</h3>
                                    </div>
                                    <div className="update-modal-field">
                                        <label className="update-modal-field-label">סוג כרטיס</label>
                                        <select
                                            className="update-modal-select"
                                            value={idishCard1Value}
                                            onChange={handleIdishCard1Change}
                                            aria-label="סוג כרטיס אידיש כארד 1"
                                        >
                                            <option value="">בחר סוג כרטיס</option>
                                            <option value={idishCardOptionA}>{idishCardOptionA}</option>
                                            <option value={idishCardOptionB}>{idishCardOptionB}</option>
                                        </select>
                                    </div>
                                    <button
                                        type="button"
                                        className="update-modal-card-button"
                                        onClick={handleApplyIdishCard1}
                                        disabled={!idishCard1Value}
                                    >
                                        {update_idishCard_2}
                                    </button>
                                </div>

                                <div className="update-modal-card">
                                    <div className="update-modal-card-header">
                                        <span className="update-modal-card-icon">💳</span>
                                        <h3 className="update-modal-card-title">אידיש כארד 2</h3>
                                    </div>
                                    <div className="update-modal-field">
                                        <label className="update-modal-field-label">סוג כרטיס</label>
                                        <select
                                            className="update-modal-select"
                                            value={idishCard2Value}
                                            onChange={handleIdishCard2Change}
                                            aria-label="סוג כרטיס אידיש כארד 2"
                                        >
                                            <option value="">בחר סוג כרטיס</option>
                                            <option value={idishCardOptionA}>{idishCardOptionA}</option>
                                            <option value={idishCardOptionB}>{idishCardOptionB}</option>
                                        </select>
                                    </div>
                                    <button
                                        type="button"
                                        className="update-modal-card-button"
                                        onClick={handleApplyIdishCard2}
                                        disabled={!idishCard2Value}
                                    >
                                        {update_idishCard}
                                    </button>
                                </div>

                                <div className="update-modal-card">
                                    <div className="update-modal-card-header">
                                        <span className="update-modal-card-icon">💰</span>
                                        <h3 className="update-modal-card-title">שינוי סכום</h3>
                                    </div>
                                    <div className="update-modal-field">
                                        <label className="update-modal-field-label">סכום</label>
                                        <input
                                            className="update-modal-input"
                                            type="number"
                                            value={sumValue}
                                            onChange={handleSumChange}
                                            placeholder="הזן סכום"
                                            aria-label="סכום לשורות ריקות"
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="update-modal-card-button"
                                        onClick={handleUpdateSum}
                                        disabled={sumValue === ""}
                                    >
                                        {update_sum}
                                    </button>
                                </div>

                                <div className="update-modal-card">
                                    <div className="update-modal-card-header">
                                        <span className="update-modal-card-icon">🧾</span>
                                        <h3 className="update-modal-card-title">שינוי כולל</h3>
                                    </div>
                                    <div className="update-modal-field">
                                        <label className="update-modal-field-label">כולל</label>
                                        <input
                                            className="update-modal-input"
                                            type="text"
                                            value={colelValue}
                                            onChange={handleColelChange}
                                            placeholder="הזן ערך"
                                            aria-label="ערך כולל לשורות ריקות"
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="update-modal-card-button"
                                        onClick={handleUpdateColel}
                                        disabled={!colelValue}
                                    >
                                        {update_colel}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default UpdateForAllModal;
